// Lightweight relative-time without pulling in date-fns just for the row/header
// chrome on the workspace. Used by both the master list and the detail panel so
// the two stay in lockstep.
export function formatRelative(iso: string): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const diffMs = Date.now() - t;
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return 'just now';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const d = Math.round(hr / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}

// CSC-293: shared localized 12-hour stamp for tooltips, posted-at metadata, and
// any other absolute timestamp display in the workspace. `hour12: true` is set
// explicitly so the format stays 12h regardless of the user's locale default
// (some locales/browsers render 24h otherwise).
export function formatDateTime12h(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
